/**
 * @fileoverview
 * 管理者認証のグローバル状態。
 *
 * Access Token そのものはここに置かない（api/client.ts のモジュール内メモリにのみ
 * 保持する）。ここには UI の出し分けに必要な認証状態とプロフィールだけを持つ。
 */

import { atom } from "jotai";

/**
 * @description 認証状態。
 * - `initializing`: 起動時のセッション復元 (refresh) を試行中
 * - `unauthenticated`: 未ログイン（ログイン画面を表示する）
 * - `authenticated`: ログイン済み（エディタ本体を表示する）
 */
export type AdminAuthStatus =
	| "initializing"
	| "unauthenticated"
	| "authenticated";

/**
 * @description ログイン中の管理者プロフィール (`GET /v1/admin/me` の `admin`)。
 */
export interface AdminProfile {
	uuid: string;
	username: string;
	display_name: string;
	role: string;
}

export const adminAuthStatusAtom = atom<AdminAuthStatus>("initializing");

export const adminProfileAtom = atom<AdminProfile | null>(null);
